import { render, staticRenderFns } from "./tag-creator.vue?vue&type=template&id=1c7c9080"
import script from "./tag-creator.vue?vue&type=script&lang=js"
export * from "./tag-creator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports